import React, { useState, useCallback } from 'react'
import { Menu, MenuItem, ListItemIcon } from '@material-ui/core'
import { TablePopoverButton } from 'civic-champs-shared/core/TablePopoverButton'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { ReactComponent as ExportIcon } from 'images/export.svg'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
  menuItem: {
    fontSize: '14px',
    padding: '8px 16px',
    minWidth: '200px',
  },
  buttonContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
})

interface ExportOption {
  label: string
  onClick: () => void | Promise<void>
  enabled: boolean
  icon?: React.ReactNode
}

interface ExportChampionsMenuProps {
  disabled: boolean
  options: ExportOption[]
  exportToLabel?: string
}

export function ExportChampionsMenu({ disabled, options, exportToLabel = 'Export to...' }: ExportChampionsMenuProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const classes = useStyles()

  const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }, [])

  const handleClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  const handleOptionClick = useCallback(
    (onClick: () => void | Promise<void>) => {
      handleClose()
      onClick()
    },
    [handleClose],
  )

  const enabledOptions = options.filter(opt => opt.enabled)

  if (enabledOptions.length === 0) {
    return null
  }

  return (
    <>
      <TablePopoverButton disabled={disabled} onClick={handleClick} startIcon={<ExportIcon />}>
        <span className={classes.buttonContent}>
          {exportToLabel} <ChevronRightIcon fontSize="small" />
        </span>
      </TablePopoverButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
      >
        {enabledOptions.map(option => (
          <MenuItem key={option.label} className={classes.menuItem} onClick={() => handleOptionClick(option.onClick)}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
